import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'device-ipad-horizontal-up',
  'IconDeviceIpadHorizontalUp',
  [
    [
      'path',
      {
        d: 'M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5',
        key: 'svg-0',
      },
    ],
    ['path', { d: 'M9 17h3.5', key: 'svg-1' }],
    ['path', { d: 'M19 22v-6', key: 'svg-2' }],
    ['path', { d: 'M22 19l-3 -3l-3 3', key: 'svg-3' }],
  ],
);
